import { render, staticRenderFns } from "./AppMultilineText.vue?vue&type=template&id=0388ebde&"
import script from "./AppMultilineText.vue?vue&type=script&lang=js&"
export * from "./AppMultilineText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports